module.exports = __webpack_public_path__ + "static/thumb-energy-ed2f50ff8fd487cb060fbee328f8d33f.png";